// Translation lookup only. This module must stay free of session/store imports so
// that the many modules reaching it through the @/utils/i18n barrel do not inherit
// the session layer's dependency graph.
//
// Locale *resolution* (which reads the active user and subscription) lives in
// i18n-locale-resolver.js.
import { createPendoI18n } from '@pendo/i18n';
import en from '@/locales/en.json';
import { normalizedLocale } from './use-i18n';
import momentTimeZone from 'moment-timezone';
import 'moment/locale/ja';
import 'moment/locale/de';
import 'moment/locale/pt-br';
import 'moment/locale/es';

momentTimeZone.locale('en');
const i18n = createPendoI18n({
    locale: 'en',
    messages: { en: Object.freeze(en) },
});

const { i18n_t } = i18n;

const i18n_locale = normalizedLocale(i18n.global.locale);

export { i18n, i18n_t, i18n_locale };
